import React from 'react';
import { ButtonBase, Grid, Typography } from '@mui/material';

import { Grey1, Grey2, Grey4 } from '../../color_utils';
import { useHistory } from "react-router";
import { formatSQLDateTimeWithSlash, trakrefFontFamily, renderMessageWithMentions } from '../../utils';
import Enums from '../../enums';
import useNavigate from '../../hooks/useNavigate';

/* const useStyles = makeStyles({
    notificationTextStyle: {
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-line-clamp': 2, // Number of lines to show
        '-webkit-box-orient': 'vertical',
        textOverflow: 'ellipsis', // Add ellipsis
        textAlign: 'left', // Align to right
        fontFamily: trakrefFontFamily,
        color: Grey2,
        fontSize: "0.75rem",
        lineHeight: "17px",
        letterSpacing: 0
    },
    notificationDateStyle: {
        overflow: 'hidden',
        display: '-webkit-box',
        textAlign: 'right',
        fontFamily: trakrefFontFamily,
        color: Grey2,
        fontSize: "0.75rem",
        lineHeight: "17px",
        letterSpacing: 0
      },
      notificationButton: {
        paddingLeft: "23.06px",
        paddingRight: "12px",
        '&:hover': {
          backgroundColor: Grey4,
      },
    }
}); */

const formattedNotification = (notification) => (
    <>
        {notification.userName} comment on {notification.noti.subject}:{' '}
        <span>{renderMessageWithMentions(notification.noti.message)}</span>
    </>
);

const NotificationDisplay = (props) => {
    // const classes = useStyles();
    
    const { isShowing, notifications, onClose } = props;

    const history = useHistory();
    const navigate = useNavigate({
        pageName: "NotificationDisplay"
    })

    const handleClick = (itemId, type, commentId) => {
        if (itemId && type && commentId) {
            switch (type) {
                case (Enums.CommentType.Asset):
                    // go to history tab, Discussion section in asset details
                    navigate.push(`/Inventory/${itemId}`, {
                        state: { activeTab: 5, secondaryActiveTab: "Discussion", initialCommentId: commentId }
                    }); 
                    break;
                case (Enums.CommentType.WorkOrder):
                    // Go to discussion tab of Work Order detail
                    navigate.push(`/WorkOrder/${itemId}`, {
                        state: { InitialActiveTab: 5, secondaryActiveTab: 4, initialCommentId: commentId }
                    }); 
                    break;
                default:
                    break;
            }
        }

        onClose();
    };

    
    if (!isShowing) {
        return null;
    }
    return (
        <Grid item sx={
            {
                position: "absolute",
                marginTop: "40px",
                paddingTop: "20px",
                paddingBottom: "22px",
                zIndex: 2,
                boxSizing: "border-box",
                maxHeight: "477px",
                width: "503px",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 8px 16px 0 rgba(0,0,0,0.1)",
            }
        }>
            <Grid item>
                <Typography 
                    variant="paragraph" 
                    style={{ 
                        color: Grey1,
                        fontFamily: {trakrefFontFamily}, 
                        fontSize: "1.155rem",
                        letterSpacing: "0.13px",
                        lineHeight: "25px",
                        paddingLeft: "23.06px",
                    }}
                >
                    Discussions
                </Typography>
            </Grid>
         
            <Grid 
                sx={{
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    maxHeight: "391px",
                    position:'relative',
                    '&::-webkit-scrollbar': {
                        backgroundColor: 'transparent',
                        width: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        height: "8px",
                        backgroundColor: 'lightgrey',
                        borderRadius: '4px',
                    },
                }}
            >
                {(notifications.length === 0) && (
                    <Grid item>
                        <Typography 
                            variant="paragraph" 
                            style={{ 
                                color: Grey1,
                                fontFamily: {trakrefFontFamily}, 
                                fontSize: "0.875rem",
                                letterSpacing: "0.13px",
                                lineHeight: "25px",
                                paddingLeft: "23.06px",
                            }}
                        >
                            There's no new notification
                        </Typography>
                    </Grid>
                )}
                {notifications.map((notification) => (
                    <ButtonBase 
                        // className={classes.notificationButton}
                        onClick={() => handleClick(notification.itemId, notification.itemType, notification.noti.commentId)}
                        sx={{
                            paddingRight: "12px",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            paddingLeft: "23.06px",
                            '&:hover': {
                                backgroundColor: Grey4,
                            }
                        }}>
                        {/* Sender Icon */}   
                        <div className="greenCircleExtraSmall">
                            {notification.shortName}
                        </div>

                        {/* Detail of Notification*/}
                        <Grid item width="373px" height="34px" align="left" marginLeft="10px" sx={{paddingRight: "20px"}}>
                            <Typography
                                // className={classes.notificationTextStyle}
                                sx={{
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    '-webkit-line-clamp': 2, // Number of lines to show
                                    '-webkit-box-orient': 'vertical',
                                    textOverflow: 'ellipsis', // Add ellipsis
                                    textAlign: 'left', // Align to right
                                    fontFamily: trakrefFontFamily,
                                    color: Grey2,
                                    fontSize: "0.75rem",
                                    lineHeight: "17px",
                                    letterSpacing: 0
                                }}
                                variant="paragraph"
                            >
                                {formattedNotification(notification)}
                            </Typography>
                        </Grid>

                        {/* Date of Notification*/}
                        <Grid item width="65px" height="34px" align="right">
                            <Typography
                                // className={classes.notificationDateStyle}
                                sx={{
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    textAlign: 'right',
                                    fontFamily: trakrefFontFamily,
                                    color: Grey2,
                                    fontSize: "0.75rem",
                                    lineHeight: "17px",
                                    letterSpacing: 0
                                }}
                                variant="paragraph"
                            >
                            {formatSQLDateTimeWithSlash(notification.noti.createDate)}
                            </Typography>
                        </Grid>
                    </ButtonBase>
                ))}
            </Grid>
        </Grid>
    );
};

export default NotificationDisplay;
